@file:OptIn(InternalResourceApi::class)

package diana.soleil.design.iraniancanadienbazzar.feature.admin.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/diana.soleil.design.iraniancanadienbazzar.feature.admin.resources/"

@delegate:ResourceContentHash(1_905_197_567)
internal val Res.string.admin_listing_requests_section: StringResource by lazy {
      StringResource("string:admin_listing_requests_section", "admin_listing_requests_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7405, 86),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6129, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5629, 62),
      ))
    }

@delegate:ResourceContentHash(1_893_568_643)
internal val Res.string.admin_make_admin: StringResource by lazy {
      StringResource("string:admin_make_admin", "admin_make_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7492, 56),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6192, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5692, 40),
      ))
    }

@delegate:ResourceContentHash(-1_079_982_741)
internal val Res.string.admin_make_moderator: StringResource by lazy {
      StringResource("string:admin_make_moderator", "admin_make_moderator", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7549, 80),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6233, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5733, 48),
      ))
    }

@delegate:ResourceContentHash(2_079_435_477)
internal val Res.string.admin_offer_days_chip: StringResource by lazy {
      StringResource("string:admin_offer_days_chip", "admin_offer_days_chip", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7630, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6286, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5782, 41),
      ))
    }

@delegate:ResourceContentHash(-1_846_284_476)
internal val Res.string.admin_offer_delete_a11y: StringResource by lazy {
      StringResource("string:admin_offer_delete_a11y", "admin_offer_delete_a11y", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7676, 59),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6332, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5824, 47),
      ))
    }

@delegate:ResourceContentHash(-255_039_185)
internal val Res.string.admin_offer_ended: StringResource by lazy {
      StringResource("string:admin_offer_ended", "admin_offer_ended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7736, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6392, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5872, 33),
      ))
    }

@delegate:ResourceContentHash(-1_290_417_592)
internal val Res.string.admin_offer_ends_days: StringResource by lazy {
      StringResource("string:admin_offer_ends_days", "admin_offer_ends_days", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7782, 89),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6430, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5906, 53),
      ))
    }

@delegate:ResourceContentHash(-519_419_127)
internal val Res.string.admin_offer_failed: StringResource by lazy {
      StringResource("string:admin_offer_failed", "admin_offer_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 7872, 130),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6496, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5960, 82),
      ))
    }

@delegate:ResourceContentHash(-1_561_421_810)
internal val Res.string.admin_offer_headline_en: StringResource by lazy {
      StringResource("string:admin_offer_headline_en", "admin_offer_headline_en", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8003, 87),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6583, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6043, 63),
      ))
    }

@delegate:ResourceContentHash(-1_542_441_193)
internal val Res.string.admin_offer_headline_fa: StringResource by lazy {
      StringResource("string:admin_offer_headline_fa", "admin_offer_headline_fa", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8091, 107),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6655, 83),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6107, 75),
      ))
    }

@delegate:ResourceContentHash(-1_713_834_073)
internal val Res.string.admin_offer_intro: StringResource by lazy {
      StringResource("string:admin_offer_intro", "admin_offer_intro", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8199, 345),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6739, 197),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6183, 209),
      ))
    }

@delegate:ResourceContentHash(603_072_911)
internal val Res.string.admin_offer_publish: StringResource by lazy {
      StringResource("string:admin_offer_publish", "admin_offer_publish", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8545, 63),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6937, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6393, 47),
      ))
    }

@delegate:ResourceContentHash(1_117_844_026)
internal val Res.string.admin_offer_title: StringResource by lazy {
      StringResource("string:admin_offer_title", "admin_offer_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8609, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 6989, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6441, 45),
      ))
    }

@delegate:ResourceContentHash(560_250_114)
internal val Res.string.admin_open_listing: StringResource by lazy {
      StringResource("string:admin_open_listing", "admin_open_listing", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8675, 70),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7035, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6487, 50),
      ))
    }

@delegate:ResourceContentHash(590_291_633)
internal val Res.string.admin_overview_subtitle: StringResource by lazy {
      StringResource("string:admin_overview_subtitle", "admin_overview_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8746, 139),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7094, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6538, 115),
      ))
    }

@delegate:ResourceContentHash(-684_863_206)
internal val Res.string.admin_overview_title: StringResource by lazy {
      StringResource("string:admin_overview_title", "admin_overview_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8886, 68),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7214, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6654, 52),
      ))
    }

@delegate:ResourceContentHash(1_396_517_131)
internal val Res.string.admin_pending_badge: StringResource by lazy {
      StringResource("string:admin_pending_badge", "admin_pending_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 8955, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7279, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6707, 39),
      ))
    }

@delegate:ResourceContentHash(-898_401_314)
internal val Res.string.admin_pending_section: StringResource by lazy {
      StringResource("string:admin_pending_section", "admin_pending_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9007, 85),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7323, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6747, 53),
      ))
    }

@delegate:ResourceContentHash(-823_797_914)
internal val Res.string.admin_post_offer: StringResource by lazy {
      StringResource("string:admin_post_offer", "admin_post_offer", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9093, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7385, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6801, 40),
      ))
    }

@delegate:ResourceContentHash(1_375_592_612)
internal val Res.string.admin_queue_subtitle: StringResource by lazy {
      StringResource("string:admin_queue_subtitle", "admin_queue_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9146, 92),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7434, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6842, 76),
      ))
    }

@delegate:ResourceContentHash(-1_590_391_749)
internal val Res.string.admin_queue_title: StringResource by lazy {
      StringResource("string:admin_queue_title", "admin_queue_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9239, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7515, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6919, 49),
      ))
    }

@delegate:ResourceContentHash(244_495_512)
internal val Res.string.admin_rail_overview: StringResource by lazy {
      StringResource("string:admin_rail_overview", "admin_rail_overview", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9285, 47),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7569, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6969, 39),
      ))
    }

@delegate:ResourceContentHash(-1_197_629_315)
internal val Res.string.admin_reject: StringResource by lazy {
      StringResource("string:admin_reject", "admin_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9626, 28),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7822, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7214, 28),
      ))
    }

@delegate:ResourceContentHash(-1_557_371_732)
internal val Res.string.admin_reject_confirm_message: StringResource by lazy {
      StringResource("string:admin_reject_confirm_message", "admin_reject_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9333, 148),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7609, 112),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7009, 104),
      ))
    }

@delegate:ResourceContentHash(2_036_390_310)
internal val Res.string.admin_reject_reason_placeholder: StringResource by lazy {
      StringResource("string:admin_reject_reason_placeholder", "admin_reject_reason_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9482, 143),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7722, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7114, 99),
      ))
    }

@delegate:ResourceContentHash(1_070_357_010)
internal val Res.string.admin_remove_confirm_message: StringResource by lazy {
      StringResource("string:admin_remove_confirm_message", "admin_remove_confirm_message", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9655, 128),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7855, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7243, 104),
      ))
    }

@delegate:ResourceContentHash(1_783_671_254)
internal val Res.string.admin_remove_role: StringResource by lazy {
      StringResource("string:admin_remove_role", "admin_remove_role", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9784, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 7964, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7348, 41),
      ))
    }

@delegate:ResourceContentHash(-1_879_295_532)
internal val Res.string.admin_remove_target: StringResource by lazy {
      StringResource("string:admin_remove_target", "admin_remove_target", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9830, 51),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8014, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7390, 47),
      ))
    }

@delegate:ResourceContentHash(1_438_334_361)
internal val Res.string.admin_report_prefix: StringResource by lazy {
      StringResource("string:admin_report_prefix", "admin_report_prefix", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9882, 43),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8066, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7438, 43),
      ))
    }

@delegate:ResourceContentHash(164_141_104)
internal val Res.string.admin_reports_section: StringResource by lazy {
      StringResource("string:admin_reports_section", "admin_reports_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9926, 65),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8110, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7482, 45),
      ))
    }

@delegate:ResourceContentHash(265_237_321)
internal val Res.string.admin_resolve: StringResource by lazy {
      StringResource("string:admin_resolve", "admin_resolve", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 9992, 105),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8168, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7528, 41),
      ))
    }

@delegate:ResourceContentHash(-845_189_000)
internal val Res.string.admin_restore_target: StringResource by lazy {
      StringResource("string:admin_restore_target", "admin_restore_target", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10098, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8218, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7570, 40),
      ))
    }

@delegate:ResourceContentHash(-574_583_101)
internal val Res.string.admin_retry: StringResource by lazy {
      StringResource("string:admin_retry", "admin_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10151, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8259, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7611, 31),
      ))
    }

@delegate:ResourceContentHash(-695_413_796)
internal val Res.string.admin_revoke_admin: StringResource by lazy {
      StringResource("string:admin_revoke_admin", "admin_revoke_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10187, 58),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8287, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7643, 42),
      ))
    }

@delegate:ResourceContentHash(1_501_961_721)
internal val Res.string.admin_role_admin: StringResource by lazy {
      StringResource("string:admin_role_admin", "admin_role_admin", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10246, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8334, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7686, 32),
      ))
    }

@delegate:ResourceContentHash(-895_528_769)
internal val Res.string.admin_role_label: StringResource by lazy {
      StringResource("string:admin_role_label", "admin_role_label", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10283, 36),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8367, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7719, 44),
      ))
    }

@delegate:ResourceContentHash(1_263_294_326)
internal val Res.string.admin_role_moderator: StringResource by lazy {
      StringResource("string:admin_role_moderator", "admin_role_moderator", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10320, 40),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8412, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7764, 40),
      ))
    }

@delegate:ResourceContentHash(-1_144_469_631)
internal val Res.string.admin_role_user: StringResource by lazy {
      StringResource("string:admin_role_user", "admin_role_user", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10361, 31),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8457, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7805, 31),
      ))
    }

@delegate:ResourceContentHash(-221_993_254)
internal val Res.string.admin_stat_claims: StringResource by lazy {
      StringResource("string:admin_stat_claims", "admin_stat_claims", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10467, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8559, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7891, 45),
      ))
    }

@delegate:ResourceContentHash(732_266_613)
internal val Res.string.admin_stat_claims_caption: StringResource by lazy {
      StringResource("string:admin_stat_claims_caption", "admin_stat_claims_caption", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10393, 73),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8489, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7837, 53),
      ))
    }

@delegate:ResourceContentHash(-665_409_547)
internal val Res.string.admin_stat_listings: StringResource by lazy {
      StringResource("string:admin_stat_listings", "admin_stat_listings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10621, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8685, 63),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8001, 51),
      ))
    }

@delegate:ResourceContentHash(1_329_788_368)
internal val Res.string.admin_stat_listings_caption: StringResource by lazy {
      StringResource("string:admin_stat_listings_caption", "admin_stat_listings_caption", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10541, 79),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8617, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7937, 63),
      ))
    }

@delegate:ResourceContentHash(187_497_622)
internal val Res.string.admin_stat_pending: StringResource by lazy {
      StringResource("string:admin_stat_pending", "admin_stat_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10776, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8816, 62),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8108, 54),
      ))
    }

@delegate:ResourceContentHash(337_335_826)
internal val Res.string.admin_stat_pending_caption: StringResource by lazy {
      StringResource("string:admin_stat_pending_caption", "admin_stat_pending_caption", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10701, 74),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8749, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8053, 54),
      ))
    }

@delegate:ResourceContentHash(164_141_104)
internal val Res.string.admin_stat_reports: StringResource by lazy {
      StringResource("string:admin_stat_reports", "admin_stat_reports", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10910, 62),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8938, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8222, 42),
      ))
    }

@delegate:ResourceContentHash(860_730_122)
internal val Res.string.admin_stat_reports_caption: StringResource by lazy {
      StringResource("string:admin_stat_reports_caption", "admin_stat_reports_caption", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10843, 66),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8879, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8163, 58),
      ))
    }

@delegate:ResourceContentHash(-475_422_787)
internal val Res.string.admin_status_approved: StringResource by lazy {
      StringResource("string:admin_status_approved", "admin_status_approved", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 10973, 41),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 8993, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8265, 37),
      ))
    }

@delegate:ResourceContentHash(1_396_517_131)
internal val Res.string.admin_status_pending: StringResource by lazy {
      StringResource("string:admin_status_pending", "admin_status_pending", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11015, 52),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9035, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8303, 40),
      ))
    }

@delegate:ResourceContentHash(-721_533_957)
internal val Res.string.admin_status_rejected: StringResource by lazy {
      StringResource("string:admin_status_rejected", "admin_status_rejected", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11068, 45),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9080, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8344, 41),
      ))
    }

@delegate:ResourceContentHash(484_290_824)
internal val Res.string.admin_status_suspended: StringResource by lazy {
      StringResource("string:admin_status_suspended", "admin_status_suspended", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11114, 42),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9122, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8386, 42),
      ))
    }

@delegate:ResourceContentHash(-215_736_948)
internal val Res.string.admin_subtitle: StringResource by lazy {
      StringResource("string:admin_subtitle", "admin_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11157, 194),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9165, 150),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8429, 110),
      ))
    }

@delegate:ResourceContentHash(-1_167_589_784)
internal val Res.string.admin_title: StringResource by lazy {
      StringResource("string:admin_title", "admin_title", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11352, 35),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9316, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8540, 27),
      ))
    }

@delegate:ResourceContentHash(375_349_847)
internal val Res.string.admin_users_section: StringResource by lazy {
      StringResource("string:admin_users_section", "admin_users_section", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), ), "${MD}values-fa/strings.commonMain.cvr", 11388, 39),
        ResourceItem(setOf(LanguageQualifier("fr"), ), "${MD}values-fr/strings.commonMain.cvr", 9356, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 8568, 39),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString1Resources(map: MutableMap<String, StringResource>) {
  map.put("admin_listing_requests_section", Res.string.admin_listing_requests_section)
  map.put("admin_make_admin", Res.string.admin_make_admin)
  map.put("admin_make_moderator", Res.string.admin_make_moderator)
  map.put("admin_offer_days_chip", Res.string.admin_offer_days_chip)
  map.put("admin_offer_delete_a11y", Res.string.admin_offer_delete_a11y)
  map.put("admin_offer_ended", Res.string.admin_offer_ended)
  map.put("admin_offer_ends_days", Res.string.admin_offer_ends_days)
  map.put("admin_offer_failed", Res.string.admin_offer_failed)
  map.put("admin_offer_headline_en", Res.string.admin_offer_headline_en)
  map.put("admin_offer_headline_fa", Res.string.admin_offer_headline_fa)
  map.put("admin_offer_intro", Res.string.admin_offer_intro)
  map.put("admin_offer_publish", Res.string.admin_offer_publish)
  map.put("admin_offer_title", Res.string.admin_offer_title)
  map.put("admin_open_listing", Res.string.admin_open_listing)
  map.put("admin_overview_subtitle", Res.string.admin_overview_subtitle)
  map.put("admin_overview_title", Res.string.admin_overview_title)
  map.put("admin_pending_badge", Res.string.admin_pending_badge)
  map.put("admin_pending_section", Res.string.admin_pending_section)
  map.put("admin_post_offer", Res.string.admin_post_offer)
  map.put("admin_queue_subtitle", Res.string.admin_queue_subtitle)
  map.put("admin_queue_title", Res.string.admin_queue_title)
  map.put("admin_rail_overview", Res.string.admin_rail_overview)
  map.put("admin_reject", Res.string.admin_reject)
  map.put("admin_reject_confirm_message", Res.string.admin_reject_confirm_message)
  map.put("admin_reject_reason_placeholder", Res.string.admin_reject_reason_placeholder)
  map.put("admin_remove_confirm_message", Res.string.admin_remove_confirm_message)
  map.put("admin_remove_role", Res.string.admin_remove_role)
  map.put("admin_remove_target", Res.string.admin_remove_target)
  map.put("admin_report_prefix", Res.string.admin_report_prefix)
  map.put("admin_reports_section", Res.string.admin_reports_section)
  map.put("admin_resolve", Res.string.admin_resolve)
  map.put("admin_restore_target", Res.string.admin_restore_target)
  map.put("admin_retry", Res.string.admin_retry)
  map.put("admin_revoke_admin", Res.string.admin_revoke_admin)
  map.put("admin_role_admin", Res.string.admin_role_admin)
  map.put("admin_role_label", Res.string.admin_role_label)
  map.put("admin_role_moderator", Res.string.admin_role_moderator)
  map.put("admin_role_user", Res.string.admin_role_user)
  map.put("admin_stat_claims", Res.string.admin_stat_claims)
  map.put("admin_stat_claims_caption", Res.string.admin_stat_claims_caption)
  map.put("admin_stat_listings", Res.string.admin_stat_listings)
  map.put("admin_stat_listings_caption", Res.string.admin_stat_listings_caption)
  map.put("admin_stat_pending", Res.string.admin_stat_pending)
  map.put("admin_stat_pending_caption", Res.string.admin_stat_pending_caption)
  map.put("admin_stat_reports", Res.string.admin_stat_reports)
  map.put("admin_stat_reports_caption", Res.string.admin_stat_reports_caption)
  map.put("admin_status_approved", Res.string.admin_status_approved)
  map.put("admin_status_pending", Res.string.admin_status_pending)
  map.put("admin_status_rejected", Res.string.admin_status_rejected)
  map.put("admin_status_suspended", Res.string.admin_status_suspended)
  map.put("admin_subtitle", Res.string.admin_subtitle)
  map.put("admin_title", Res.string.admin_title)
  map.put("admin_users_section", Res.string.admin_users_section)
}
